import { NAVIGATE_STEP_KEYS } from '../../store/configureAccount/types';
import WelcomeImage from '../../images/modals/modalWelcome.png';
import SuccessImage from '../../images/modals/modalCompleteRegistration.png';
import { ModalType } from '../Root/models';
export var useConfigureModalSchema = function (step, type) {
    if (step === NAVIGATE_STEP_KEYS.START && type === ModalType.WELCOME) {
        return {
            title: 'Welcome to Appspotr!',
            description: 'Before you can start working your app-building magic you need to complete your registration.',
            description2: 'Just click "Continue" and we’ll get you set up in no time.',
            image: WelcomeImage,
            isContentCentered: true,
            primaryButtonText: 'Continue',
        };
    }
    if (step === NAVIGATE_STEP_KEYS.START && type === ModalType.CONFIGURE) {
        return {
            title: 'Activate Your Account',
            description: 'Once your first week of free trial is over, you need to complete your registration to unlock 7 more days.',
            description2: 'Just click "Continue" and we’ll walk you through the process in no time.',
            isContentCentered: true,
            image: WelcomeImage,
            primaryButtonText: 'Continue',
        };
    }
    if (step === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION) {
        return {
            title: 'Verify Your Email Address',
            description: 'Are you really you? Prove it!',
            isContentCentered: true,
            primaryButtonText: 'Continue',
        };
    }
    if (step === NAVIGATE_STEP_KEYS.DEV_PLAN_SELECTION) {
        return {
            title: 'Select a Developer Plan',
            description: 'Choose the Developer Plan that best fits your needs. You’ll be able to upgrade or downgrade your Plan, or cancel your subscription, at any time.',
            primaryButtonText: 'Continue',
        };
    }
    if (step === NAVIGATE_STEP_KEYS.CARD_DETAILS) {
        return {
            title: 'Add Your Payment Details',
            description: 'The card you provide will be used for all future payments.',
            description2: 'We won’t charge you a dime until your free-trial period has ended.',
            primaryButtonText: 'Confirm',
            isContentCentered: true,
        };
    }
    if (step === NAVIGATE_STEP_KEYS.SUCCESS) {
        return {
            title: 'Registration Complete',
            description: 'You have successfully set up your account. It’s time to build apps and chew bubblegum!',
            description2: 'If you get stuck anywhere, tap into the infinite wisdom documented over at <a href="https://academy.appspotr.com/academy/latest/getting-started/create-app/index.html" target="_blank">Appspotr Academy</a> or reach out to our <a href="https://appspotr.atlassian.net/servicedesk/customer/portals" target="_blank">Service Desk</a>.',
            isContentCentered: true,
            image: SuccessImage,
            primaryButtonText: 'Start building',
        };
    }
    return {
        title: '',
        description: '',
        primaryButtonText: '',
    };
};
